module.exports = "/_next/static/images/hero-d88405ed8c401be115e8a302b0ccc66c.jpg";